import { environment } from './../../../environments/environment';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Dashboard, Files } from './../../shared/interceptors/token.interceptors';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AusentismoService {
  public headers: HttpHeaders = new HttpHeaders({}).set(Dashboard, 'Dashboard');
  public headers_file: HttpHeaders = new HttpHeaders({}).set(Files, 'Files');

  constructor(private _http: HttpClient) { }

  /**
   * Trae los registros de ausentismo, la ruta recibe los siguientes filtros
   * @param tipo_ausencia
   * @param motivo_ausencia
   * @param estado
   * @param cedula
   * @param nombre
   * @param fecha_inicio
   * @param fecha_fin
   */
  getRegistrosAusentismo(
    current_page: number,
    filtros: {
      nombre?: string;
      cedula?: number;
      estado?: number;
      tipo_ausencia?: number;
      motivo_ausencia?: number;
      fecha_inicio?: string;
      fecha_fin?: string;
    }
  ) {
    const params =
      `?paginate=1` +
      `&page=${current_page || 1}` +
      (filtros.tipo_ausencia ? `&tipo_ausencia=${filtros.tipo_ausencia}` : '') +
      (filtros.motivo_ausencia ? `&motivo_ausencia=${filtros.motivo_ausencia}` : '') +
      (filtros.estado ? `&estado=${filtros.estado}` : '') +
      (filtros.cedula ? `&cedula=${filtros.cedula}` : '') +
      (filtros.nombre ? `&nombre=${filtros.nombre}` : '') +
      (filtros.fecha_inicio ? `&fecha_inicio=${filtros.fecha_inicio} 00:00` : '') +
      (filtros.fecha_fin ? `&fecha_fin=${filtros.fecha_fin} 23:59` : '');

    console.log(params);

    return this._http.get(environment.ausentismo.GET_REGISTROS_AUSENTISMO + params, { headers: this.headers });
  }

  /**
  * Trae los registros de ausentismo, la ruta recibe los siguientes filtros
  * @param tipo_ausencia
  * @param motivo_ausencia
  * @param estado
  * @param cedula
  * @param nombre
  * @param fecha_inicio
  * @param fecha_fin
  */
  getRegistrosAusentismoRecepcionista(
    current_page: number,
    filtros: {
      nombre?: string;
      cedula?: number;
      estado?: number;
      tipo_ausencia?: number;
      motivo_ausencia?: number;
      fecha_inicio?: string;
      fecha_fin?: string;
    }
  ) {
    const params =
      `?paginate=1` +
      `&page=${current_page || 1}` +
      (filtros.tipo_ausencia ? `&tipo_ausencia=${filtros.tipo_ausencia}` : '') +
      (filtros.motivo_ausencia ? `&motivo_ausencia=${filtros.motivo_ausencia}` : '') +
      (filtros.estado ? `&estado=${filtros.estado}` : '') +
      (filtros.cedula ? `&cedula=${filtros.cedula}` : '') +
      (filtros.nombre ? `&nombre=${filtros.nombre}` : '') +
      (filtros.fecha_inicio ? `&fecha_inicio=${filtros.fecha_inicio} 00:00` : '') +
      (filtros.fecha_fin ? `&fecha_fin=${filtros.fecha_fin} 23:59` : '');

    console.log(params);

    return this._http.get(environment.ausentismo.GET_REGISTROS_AUSENTISMO_RECEPCIONISTA + params, { headers: this.headers });
  }

  /**
   * Trae los registros de ausentismo, la ruta recibe los siguientes filtros
   * @param tipo_ausencia
   * @param motivo_ausencia
   * @param estado
   * @param cedula
   * @param nombre
   * @param fecha_inicio
   * @param fecha_fin
   */
  getRegistrosExcel(
    current_page: number,
    filtros: {
      nombre?: string;
      cedula?: number;
      estado?: number;
      tipo_ausencia?: number;
      motivo_ausencia?: number;
      fecha_inicio?: string;
      fecha_fin?: string;
    }
  ) {
    const params =
      `?paginacion=0` +
      `&page=0` +
      (filtros.tipo_ausencia ? `&tipo_ausencia=${filtros.tipo_ausencia}` : '') +
      (filtros.motivo_ausencia ? `&motivo_ausencia=${filtros.motivo_ausencia}` : '') +
      (filtros.estado ? `&estado=${filtros.estado}` : '') +
      (filtros.cedula ? `&cedula=${filtros.cedula}` : '') +
      (filtros.nombre ? `&nombre=${filtros.nombre}` : '') +
      (filtros.fecha_inicio ? `&fecha_inicio=${filtros.fecha_inicio} 00:00` : '') +
      (filtros.fecha_fin ? `&fecha_fin=${filtros.fecha_fin} 23:59` : '');

    console.log(params);

    return this._http.get(environment.ausentismo.GET_REGISTROS_AUSENTISMO + params, { headers: this.headers });
  }



  /**
   * Trae los registros de ausentismo, la ruta recibe los siguientes filtros
   * @param tipo_ausencia
   * @param motivo_ausencia
   * @param estado
   * @param cedula
   * @param nombre
   * @param fecha_inicio
   * @param fecha_fin
   */
  getRegistrosExcelRecepcionista(
    current_page: number,
    filtros: {
      nombre?: string;
      cedula?: number;
      estado?: number;
      tipo_ausencia?: number;
      motivo_ausencia?: number;
      fecha_inicio?: string;
      fecha_fin?: string;
    }
  ) {
    const params =
      `?paginacion=0` +
      `&page=0` +
      (filtros.tipo_ausencia ? `&tipo_ausencia=${filtros.tipo_ausencia}` : '') +
      (filtros.motivo_ausencia ? `&motivo_ausencia=${filtros.motivo_ausencia}` : '') +
      (filtros.estado ? `&estado=${filtros.estado}` : '') +
      (filtros.cedula ? `&cedula=${filtros.cedula}` : '') +
      (filtros.nombre ? `&nombre=${filtros.nombre}` : '') +
      (filtros.fecha_inicio ? `&fecha_inicio=${filtros.fecha_inicio} 00:00` : '') +
      (filtros.fecha_fin ? `&fecha_fin=${filtros.fecha_fin} 23:59` : '');

    console.log(params);

    return this._http.get(environment.ausentismo.GET_REGISTROS_AUSENTISMO_RECEPCIONISTA + params, { headers: this.headers });
  }

  /**
   * Estados de ausentismo
   */
  getEstadosAusentismo() {
    return this._http.get(environment.ausentismo.GET_ESTADO_AUSENTISMO, {
      headers: this.headers,
    });
  }
  /**
   * Tipos de ausencia
   */
  getTiposAusencia() {
    return this._http.get(environment.ausentismo.GET_TIPO_AUSENCIA, {
      headers: this.headers,
    });
  }
  /**
   * Motivos de ausencia
   */
  getMotivosAusencia() {
    return this._http.get(environment.ausentismo.GET_MOTIVOS_AUSENTISMO, {
      headers: this.headers,
    });
  }
  /**
   * Cambiar estado a un registro de ausentismo
   */
  postCambiarEstadoRegistro(id_registro_ausentismo: number, estado: number) {
    return this._http.post(
      environment.ausentismo.POST_RESPONDER_REGISTRO,
      { id_registro_ausentismo, estado },
      { headers: this.headers }
    );
  }
  /**
   * Estadisticas de ausentismo
   */
  getEstadisticasAusentismo(filtros: { fecha_inicio?: string; fecha_fin?: string }) {
    const params =
      `?paginate=1` +
      (filtros.fecha_inicio ? `&start_date=${filtros.fecha_inicio} 00:00` : '') +
      (filtros.fecha_fin ? `&end_date=${filtros.fecha_fin} 23:59` : '');

    console.log(params);

    return this._http.get(environment.ausentismo.GET_ESTADISTICAS_AUSENTISMO + params, {
      headers: this.headers,
    });
  }

  /**
   * Anular orden de ausentismo
   */
  postAnularausentismoOrden(id) {
    const body = { id_registro_ausentismo: id };
    return this._http.post(environment.talento.POST_ANULAR_TH_AUSENTISMO, body, {
      headers: this.headers,
    });
  }

  /**
   * Eliminar ausentismos que ya estén rechazados
   */
  postRemoveRejecteds(id) {
    const body = { id_registro_ausentismo: id };
    return this._http.post(environment.talento.POST_ELIMINAR_RECHAZADOS_TH_AUSENTISMO, body, {
      headers: this.headers,
    });
  }
}
